import {gql} from "@apollo/client";

export const CREATE_BANK_ACCOUNT = gql`
  mutation CreateBankAccount($data: BankAccountCreateInput!) {
    createBankAccount(data: $data) {
      id
    }
  }
`;

export const UPDATE_BANK_ACCOUNT = gql`
  mutation UpdateBankAccount($data: BankAccountUpdateInput!, $where: BankAccountWhereUniqueInput!) {
    updateBankAccount(data: $data, where: $where) {
      id
    }
  }
`;